<div fxLayout="column" fxLayoutGap="16px">
  <strong>{{'status_settings.duration' | translate}}: {{status.defaultDuration ? getDurationToShow() : ('duration.ask_every_time' | translate)}}</strong>
  <mat-radio-group [(ngModel)]="durationButtonGroupValue" (ngModelChange)="updateDurationDefaults()" fxLayout="column" fxLayoutGap="16px">
    <mat-radio-button value="0">{{ 'duration.ask_every_time' | translate }}</mat-radio-button>
    <mat-radio-button value="1">{{ 'duration.use_duration' | translate }}</mat-radio-button>
    <mat-grid-list *ngIf="durationButtonGroupValue === '1'" cols="3" rowHeight="50px">
      <mat-grid-tile *ngFor="let duration of defaultDurations">
        <button mat-raised-button class="settingsButton"
                [color]="duration.key === status.defaultDuration ? 'primary' : ''"
                (click)="changeDefaultDuration(duration.key)">
          {{duration.text | translate}}
        </button>
      </mat-grid-tile>
    </mat-grid-list>
    <mat-radio-button value="2">{{'duration.other_duration' | translate}}</mat-radio-button>
    <div *ngIf="durationButtonGroupValue === '2'">
      <mat-form-field>
        <mat-select floatLabel="never"
                   (selectionChange)="changeDefaultDuration(durationAmountHolder*durationEntityHolder)"
                   [(ngModel)]="durationAmountHolder">
          <mat-option *ngFor="let amount of durationAmountSelector" [value]="amount">{{amount}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select floatLabel="never"
                   (selectionChange)="changeDefaultDuration(durationAmountHolder*durationEntityHolder)"
                   [(ngModel)]="durationEntityHolder">
          <mat-option *ngFor="let entity of durationEntitySelector" [value]="entity.multiplier">{{entity.text | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-radio-group>
  <button mat-raised-button (click)="onBack()" color="primary">
    {{'global.back' | translate}}
  </button>
</div>


